module.exports = __webpack_public_path__ + "static/media/drs.272f482f.jpg";